import type { TourSpec } from "./types";

export const housingTour: TourSpec = {
  id: "housing",
  version: 3,
  buildSteps: (t) => [
    {
      target: '[data-tour="housing-region-progress"]',
      title: t("housing.dataFreshness.title"),
      content: t("housing.dataFreshness.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="housing-filter-sidebar"]',
      title: t("housing.filters.title"),
      content: t("housing.filters.body"),
      placement: "right",
    },
    {
      target: '[data-tour="filter-mode-toggle"]',
      title: t("filterMode.title"),
      content: t("filterMode.body"),
      placement: "right",
    },
    {
      target: '[data-tour="housing-stats-section"]',
      title: t("housing.stats.title"),
      content: t("housing.stats.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="housing-data-table"]',
      title: t("housing.table.title"),
      content: t("housing.table.body"),
      placement: "top",
    },
    {
      target: '[data-tour="row-actions-menu"]',
      title: t("rowActions.title"),
      content: t("rowActions.body"),
      placement: "bottom-start",
    },
    {
      target: '[data-tour="housing-pagination"]',
      title: t("housing.pagination.title"),
      content: t("housing.pagination.body"),
      placement: "top",
    },
  ],
};
